import React from 'react';
import {Button, Modal} from "react-bootstrap";
import {DataAPI, MutationAPI, useData, useMutator} from "../../services/API";
import type {UserAdminInfo} from "../../services/API";
import {RouteComponentProps, useParams} from "react-router-dom";
import {ModalUrl, useHandleClose} from "../../commons/ModalHelpers";
import UsersTab from "../UsersTab";
import Notifications from "../Notifications";
import {useQueryClient} from "react-query";

const DeleteUser = (props: RouteComponentProps) => {

    const { id } = useParams();
    const queryClient = useQueryClient();

    const { isLoading, error, data } = useData(id, 'managed-user', DataAPI.getManagedUser);

    const handleClose = useHandleClose(UsersTab.url);
    //po usunięciu nie wolno cofać historii - poprzednim wpisem bywa modal edycji tego konta
    const handleDeleteClose = useHandleClose(UsersTab.url, true);
    const deleteUser = useMutator(MutationAPI.deleteUser, {
        afterSuccess: () => {
            queryClient.invalidateQueries('user-list');
            queryClient.removeQueries(['managed-user', id], { exact: true });
            handleDeleteClose();
        }
    });

    const handleDelete = () => deleteUser.mutate(id);

    if (isLoading) return null;
    if (error) {
        Notifications.pushNew(error.message, 'danger');
        return null;
    }

    const user: UserAdminInfo = data;

    return (
        <Modal size="sm" show={true} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Usuń użytkownika</Modal.Title>
            </Modal.Header>
            <Modal.Body className="confirm-body">
                <p>Czy na pewno chcesz usunąć użytkownika <strong>{user.username}</strong>?</p>
                <p className="text-danger">Operacji nie da się cofnąć. Skasowane zostaną też jego powiadomienia o stanach drukarek.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>Anuluj</Button>
                <Button variant="danger" onClick={handleDelete}>Usuń</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteUser;

DeleteUser.url = `/users${ModalUrl}delete/:id`;
DeleteUser.buildUrl = user => DeleteUser.url.replace(':id', user)
